import { useEffect } from 'react';
import { DEFAULT_OG_IMAGE, PAGE_SEO, SITE_URL } from '../components/website/seoConfig';

function setMetaByName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setMetaByProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(url) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
}

/**
 * Updates document title and primary meta tags for SPA pages.
 * Pass a key from PAGE_SEO or a custom { title, description, path, robots } object.
 */
export function usePageSeo(pageKeyOrConfig) {
  useEffect(() => {
    const config =
      typeof pageKeyOrConfig === 'string'
        ? PAGE_SEO[pageKeyOrConfig]
        : pageKeyOrConfig;

    if (!config) return;

    const title = config.title;
    const description = config.description;
    const path = config.path || window.location.pathname;
    const url = `${SITE_URL}${path === '/' ? '/' : path}`;
    const image = config.image || DEFAULT_OG_IMAGE;
    const robots = config.robots || 'index, follow';

    document.title = title;
    setMetaByName('description', description);
    setMetaByName('robots', robots);
    setMetaByProperty('og:title', title);
    setMetaByProperty('og:description', description);
    setMetaByProperty('og:url', url);
    setMetaByProperty('og:image', image);
    setMetaByProperty('og:type', 'website');
    setMetaByName('twitter:title', title);
    setMetaByName('twitter:description', description);
    setMetaByName('twitter:image', image);
    setCanonical(url);
  }, [pageKeyOrConfig]);
}
